import { render } from "./delete-user.vue?vue&type=template&id=2762da6a"
import script from "./delete-user.vue?vue&type=script&lang=js"
export * from "./delete-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__